<div class="page-container" style="min-height:188.38330078125px">

  <!-- Page content -->
  <div class="page-content">

    <div class="visible-xs-block text-center">
      <a [attr.href] = "null" (click)="showSidebar()"><i class="{{toogleSidebar ? 'icon-minus3' : 'icon-plus3'}}"></i> {{'Sidebar Menu' | translate}}</a>
      <br><br>
    </div>

    <!-- Secondary sidebar -->
    <div class="sidebar sidebar-main sidebar-default sidebar-separate">
      <div class="sidebar-content">

        <ul class="dropdown-menu" style="display: block; position: static; width: 100%; margin-top: 0; float: none;">
          <li [ngClass]="{ 'selected-media': selectedItem == 'All Documents'}">
            <a (click)="DefaultView('All Documents')"><i class="icon-home4"></i> {{'All Documents' | translate}}</a>
          </li>
          <li [ngClass]="{ 'selected-media': selectedItem == 'Inbox' }">
            <a (click)="DefaultView('Inbox')"><i class="icon-inbox-alt"></i> {{'Inbox' | translate}}</a>
          </li>
          <li [ngClass]="{ 'selected-media': selectedItem == 'Archive' }">
            <a (click)="DefaultView('Archive')"><i class="icon-archive"></i> {{'Archive' | translate}}</a>
          </li>
        </ul>

        <br>

        <!-- Online users -->

        <div class="sidebar-category allDocs">

            <div class="category-title">
              <span><i class="icon-power3 position-left"></i>{{translate.instant('Smart Views')}}</span>
              <!-- <ul class="icons-list"><li><a href="#" data-action="collapse" class=""></a></li> </ul> -->
            </div>
            <ul class="dropdown-menu" style="display: block; position: static; width: 100%; margin-top: 0; float: none;">
              <li  [ngClass]="{ 'selected-media': selectedItem == 'Waiting For Me' }">
                <a [attr.href]="null"  (click)="showSmartStatus('Waiting For Me')"><span>{{'Waiting For Me' | translate}} <span class="badge badge-info">{{smartStatus.waitingForMe}}</span></span></a>
              </li>
              <li [ngClass]="{ 'selected-media': selectedItem == 'Waiting For Others' }">
                <a [attr.href]="null" (click)="showSmartStatus('Waiting For Others')"><span>{{'Waiting For Others' | translate}} <span class="badge badge-info">{{smartStatus.waitingForOthers}}</span></span></a>
              </li>
              <li [ngClass]="{ 'selected-media': selectedItem == 'Completed' }">
                <a [attr.href]="null" (click)="showSmartStatus('Completed')"><span>{{'Completed' | translate}} <span class="badge badge-info">{{smartStatus.completed}}</span></span></a>
              </li>
              <li [ngClass]="{ 'selected-media': selectedItem == 'My Jobs' }">
                <a [attr.href]="null" (click)="showSmartStatus('My Jobs')"><span>{{'My Jobs' | translate}} <span class="badge badge-info">{{smartStatus.myJobs}}</span></span></a>
              </li>
            </ul>
        </div>

        <div *ngIf="tagList?.summary" class="sidebar-category allDocs">

            <div class="category-title">
              <span><i class="icon-price-tag3 position-left"></i>{{translate.instant('Labels')}}</span>
            </div>
              <!-- <ul class="icons-list">
                       <li><a href="#" data-action="collapse" class=""></a></li>
               </ul> -->
            <ul class="dropdown-menu" *ngFor="let tag of tagList?.summary; let i=index" style="display: block; position: static; width: 100%; margin-top: 0; float: none;">
              <li [ngClass]="{ 'selected-media': selectedItem == tag.name }">
                <a [attr.href]="null" (click)="showSelectedTag(tag)"><span>{{tag?.name}} <span class="badge badge-info">{{tag?.count}}</span></span></a>
              </li>
            </ul>
           <a *ngIf="!showTagDetails" [attr.href]="null" (click)="showTagDetails=true"><span style="font-size:30px; text-align:center; left: 100px; position: relative;">...</span></a>
           <div *ngIf="showTagDetails">
             <br>
              <ul class="dropdown-menu" *ngFor="let tag of tagList?.details; let i=index" style="display: block; position: static; width: 100%; margin-top: 0; float: none;">
                <li [ngClass]="{ 'selected-media': selectedItem == tag.name }">
                  <a [attr.href]="null" (click)="showSelectedTag(tag)"><span>{{tag?.name}} <span class="badge badge-info">{{tag?.count}}</span></span></a>
                </li>
              </ul>
           </div>
        </div>

        <!-- /online users -->

        <ul class="dropdown-menu" style="display: block; position: static; width: 100%; margin-top: 0; float: none;">
          <li [ngClass]="{ 'selected-media': selectedItem == 'Templates'}">
            <a (click)="DefaultView('Templates')"><i class="icon-copy2"></i> {{'Templates' | translate}}</a>
          </li>
        </ul>


      </div>
      <!-- /sidebar content-->
    </div>
    <!-- /secondary sidebar -->


    <!-- Main content -->
    <div class="content-wrapper">

      <!-- Task manager table -->
      <div class="panel panel-white">
        <div class="panel-heading">
          <h6 #panelTitle class="panel-title"><input type="checkbox" [checked]="isAllSelected" [indeterminate]="isIndeterminate" (change)="selectAll($any($event.target).checked)" /> {{selectedItem ? translate.instant(selectedItem) : translate.instant('All Documents')}}</h6>
        </div>

        <div id="DataTables_Table_0_wrapper" class="dataTables_wrapper no-footer">
          <div class="datatable-scroll-wrap">
            <table class="table datatable-autofill-basic dataTable no-footer tasks-list table-hover infinite-list table-lg table-md table-sm table-xs"
                   id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
              <tbody>
              <tr *ngFor="let job of jobList; trackBy: trackByJobId" role="row" class="odd" [ngClass]="{'active': isSelected(job.id)}">
                <td [ngStyle]="{'display': selectedItem=='Templates' ? 'none': ''}" class="col-md-0-5 col-sm-1 col-xs-1 text-right">
                  <input type="checkbox" [checked]="isSelected(job.id)" (change)="updateJobSelectionList(job.id, $any($event.target).checked)" />
                </td>
                <td  class="sorting_1 col-md-9 col-sm-8 col-xs-8" [ngStyle]="{'padding-left': selectedItem=='Templates' ? '20px': ''}">
                  <div style="display: flex; align-items: center;">
                    <div id="job-name" class="text-semibold" style="font-size: 16px;"><a (click)="selectedItem == 'Templates' ? editTemplate(job) : gotoJob(job.id)">{{job.name}}</a></div>
                    <span *ngIf="selectedItem == 'Templates' && isApiVersionMismatch(job)" style="color: #ff8c00; font-size: 20px; margin-left: 10px; cursor: help;" [title]="'TEMPLATE_OLD_COORDINATE_SYSTEM' | translate">⚠</span>
                  </div>
                  <div *ngIf="job.recipients.length == 1" class="text-muted">
                    <span *ngFor="let recipient of job.recipients;">{{recipient.name}}</span>
                  </div>
                  <div *ngIf="job.recipients.length == 2" class="text-muted">
                    <span>{{ job.recipients[0].name + ", " + job.recipients[1].name }}</span>
                  </div>
                  <div *ngIf="job.recipients.length == 3" class="text-muted">
                    <span>{{ job.recipients[0].name + ", " + job.recipients[1].name + ", " + job.recipients[2].name }}</span>
                  </div>
                  <div *ngIf="job.recipients.length > 3" class="text-muted">
                    <span #firstThreeRecipients>{{ job.recipients[0].name + ", " + job.recipients[1].name + ", " + job.recipients[2].name }}
                      <a id="recipientList" (mouseover)="mouseOver(job.recipients)" (click)="InitializePopover()"> <i class="icon-menu"></i></a>
                    </span>
                  </div>
                 <!-- <div *ngIf="job.recipients.length > 3" class="text-muted" id="recipientList">
                    <span #firstThreeRecipients>{{ job.recipients[0].name + ", " + job.recipients[1].name + ", " + job.recipients[2].name }} <a
                      (click)="firstThreeRecipients.innerHTML = ''"> ...</a></span>
                  </div>-->
                </td>
                <td class="col-md-1 col-sm-1 col-xs-1">
                  <div *ngIf="job.status == 'REJECTED'" class="btn-group">
                    <a class="label label-danger dropdown-toggle" data-toggle="dropdown" translate>REJECTED</a>
                  </div>
                  <div *ngIf="job.status == 'COMPLETED'" class="btn-group">
                    <a class="label label-success dropdown-toggle" data-toggle="dropdown" translate>COMPLETED</a>
                  </div>
                  <div *ngIf="job.status == 'IN_PROGRESS'" class="btn-group">
                    <a class="label label-warning dropdown-toggle" data-toggle="dropdown" translate>IN_PROGRESS</a>
                  </div>
                  <div *ngIf="job.status == 'DRAFT'" class="btn-group">
                    <a class="label label-default dropdown-toggle" data-toggle="dropdown" translate>DRAFT</a>
                  </div>
                  <!--<div *ngIf="job.status == 'NONE'" class="btn-group">
                    <a class="label dropdown-toggle" data-toggle="dropdown" translate>NONE</a>
                  </div>-->
                </td>
                <td class="col-md-1 col-sm-1 col-xs-1">
                  <div class="input-group input-group-transparent">
                    <div class="input-group-addon"><i class="icon-calendar2 position-left"></i></div>
                    <input style="width:70px;" class="form-control datepicker hasDatepicker"
                           value="{{job.updated | date: 'dd/MM/yyyy'}}" id="dp1480878519738" type="text">
                  </div>
                </td>
                <td class="col-md-0-5 col-sm-1 col-xs-1 text-left">
                  <ul class="icons-list">
                    <li class="dropdown">
                      <a [attr.href]="null" (click)="locationSettings(job); scrollDown($event.target)" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="false"><span
                        class="glyphicon glyphicon-cog"></span></a>
                      <ul class="dropdown-menu dropdown-menu-right">
                        <li *ngIf="selectedItem == 'Templates'"><a [attr.href]="null" (click)="newJobFromTemplate(job)"><i class="icon-file-empty"></i> {{'New Document From Template' | translate}}</a></li>
                        <li *ngIf="selectedItem == 'Templates'"><a [attr.href]="null" (click)="editTemplate(job)"><i class="icon-pencil3"></i> {{'Edit Template' | translate}}</a></li>
                        <li *ngIf="selectedItem == 'Templates' && job.type != 'SELF'" [ngClass]="{'disabled-view': !canCreatePublicLink}"><a [attr.href]="null" (click)="newPublicLinkFromTemplate(job)"><i class="icon-link2"></i> {{'New Public Link From Template' | translate}}</a></li>
                        <li *ngIf="selectedItem == 'Templates' && job.type != 'SELF'" [ngClass]="{'disabled-view': !canCreatePublicLink}"><a [attr.href]="null" (click)="bulkRequestwithCSV(job)"><i class="icon-cog"></i> {{'Bulk Request with CSV' | translate}}</a></li>
                        <li *ngIf="selectedItem != 'Templates'"><a [attr.href]="null" (click)="gotoJob(job.id)"><i class="icon-folder-open"></i>{{'Open' | translate}}</a></li>
                        <li><a *ngIf="selectedItem == 'Templates'" [attr.href]="null" (click)="renamingTemplate = job" data-toggle="modal" data-target="#templateRenameModal"><i class="icon-pencil"></i>{{'Change Name' | translate}}</a></li>
                        <li><a *ngIf="selectedItem == 'Templates'" [attr.href]="null" (click)="deleteTemplate(job.id, job.name)"><i class="icon-folder-remove"></i>{{'Delete' | translate}}</a></li>
                        <li><a *ngIf="selectedItem != 'Templates'" [attr.href]="null" (click)="DeleteJob(job.id, job.name)"><i class="icon-folder-remove"></i>{{'Delete' | translate}}</a></li>
                        <li *ngIf="selectedItem != 'Templates'"><a [attr.href]="null" (click)="setLocation(job)" [innerHTML]="newLocationInnerHtml"></a></li>
                        <li *ngIf="job.status == 'COMPLETED'"><a [attr.href]="null" (click)="downloadDocument(job?.documents[0]?.id, job?.name + '.pdf', 'original')"><i class="icon-file-download"></i>{{'Download Original' | translate}}</a></li>
                        <li *ngIf="job.status == 'COMPLETED'"><a [attr.href]="null" (click)="downloadDocument(job?.documents[0]?.id, job?.name + '.pdf', 'signed')"><i class="icon-file-download2"></i>{{'Download Signed Document' | translate}}</a></li>
                        <li *ngIf="job.status != 'NONE' && authorization.userProfile?.email == job.user.email"><a [attr.href]="null" (click)="createTemplateModal(job?.id)"><i class="icon-copy2"></i>{{'Create Template' | translate}}</a></li>
                        <li *ngIf="job.status == 'NONE' && authorization.userProfile?.email == job.user.email && selectedItem != 'Templates'"><a class="dropdown-item" [attr.href]="null" (click)="getTemplates(true); jobIdForTemplate=job?.id" data-toggle="modal" data-target="#templateJobs"><i class="icon-copy"></i>{{'Apply Template' | translate}}</a></li>
                      </ul>
                    </li>
                  </ul>
                </td>
              </tr>
              <tr *ngIf="selectedItem == 'Inbox' && recordCount == 0">
                <td><strong translate>You have no document. Please use the 'New' button to upload a new document</strong></td>
              </tr>
              <tr *ngIf="selectedItem == 'Templates' && recordCount == 0">
                <td><strong translate>You have no template.</strong></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
      <!-- /task manager table -->

    </div>
    <!-- /main content -->

  </div>
  <!-- /page content -->

</div>

<!-- Modal -->
<div id="newJob" class="modal fade" tabindex="-1" role="dialog">
  <sd-newJob (refreshJob)="refreshJob($event)"></sd-newJob>
</div>

<div id="templateJobs" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-lg center-modal" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <button class="close" type="button" data-dismiss="modal">×</button>
        <h5 class="text-semibold modal-title" translate>Templates</h5>
      </div>
      <div class="modal-body">
        <br>
        <ul class="list-group" *ngFor="let templateJob of templateJobs;">
          <li class="list-group-item">
            <div class="row position">
              <div class="col-xs-10">
                <div style="font-weight: bold; font-size: 16px; display: flex; align-items: center;">
                                {{templateJob.name}}
                                <span *ngIf="isApiVersionMismatch(templateJob)" style="color: #ff8c00; font-size: 20px; margin-left: 10px; cursor: help;" [title]="'TEMPLATE_OLD_COORDINATE_SYSTEM' | translate">⚠</span>
                              </div>
                <span *ngFor="let recipient of templateJob.recipients; let isLast=last" class="text-muted">
                  {{recipient.name}}{{isLast ? '' : ', '}}
                </span>
              </div>
              <div class="col-xs-2 text-right">
                <button class="btn btn-primary" type="button" (click)="chooseTemplate(templateJob)" translate>Choose</button>
              </div>
            </div>
          </li>
        </ul>

      </div>
      <div class="modal-footer">
        <button class="btn btn-link" type="button" data-dismiss="modal" translate>Cancel</button>
      </div>
    </div>
  </div>
</div>

<!--Modal Name-->
<div id="templateRenameModal" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-md center-modal" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <button class="close" type="button" data-dismiss="modal">×</button>
        <h5 class="text-semibold modal-title" translate>Change Name</h5>
      </div>
      <div class="modal-body">
        <div class="row col-sm-10 col-sm-offset-1">
          <div class="form-group">
            <label>Name:</label>
            <input class="form-control" type="text" [(ngModel)]="renamingTemplate.name">
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-link" type="button" data-dismiss="modal" translate>Close</button>
        <button class="btn btn-primary" type="button" (click)="renameTemplate()" data-dismiss="modal" translate>Change</button>
      </div>
    </div>
  </div>
</div>

<div id="newPublicLinkFromTemplate" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-lg center-modal" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <button class="close" type="button" data-dismiss="modal">×</button>
        <h5 class="text-semibold modal-title" translate>Public Link</h5>
      </div>
      <div class="modal-body">
        <div class="container-fluid">
          <div class="form-group row position">
            <label for="description" class="col-sm-2 col-form-label"><strong translate>Description</strong></label>
            <div class="col-sm-10">
              <textarea id="description" class="form-control" [(ngModel)]="publicLinkDescription" rows="6" cols="50"> </textarea>
            </div>
          </div>
          <br>
          <!-- Show when no recipient groups -->
          <div *ngIf="!recipientGroups || recipientGroups.length === 0" class="alert alert-warning">
            <i class="icon-warning"></i> <span translate>No recipients configured for this template</span>
          </div>

          <!-- Render recipient groups -->
          <div *ngFor="let group of recipientGroups; let i = index" class="recipient-group">
            <div class="panel panel-flat border-grey-300 border-info inner-shadow">
              <div class="panel-body">
                <div class="row">
                  <!-- Order number column -->
                  <div class="col-md-1 col-sm-1 col-xs-1 text-center">
                    <div class="order-badge">
                      <strong>{{i+1}}</strong>
                    </div>
                  </div>

                  <!-- Recipients list -->
                  <div class="col-md-11 col-sm-11 col-xs-11 border-left">
                    <ul class="list-group no-border">
                      <li *ngFor="let recipient of group.recipients; let x = index" class="recipient-item">
                        <div class="row align-items-center"
                             style="padding: 10px 5px"
                             [ngStyle]="{
                               'background-color': linkCheckBox.checked ? '#EBEBEB' : 'transparent',
                               'font-weight': linkCheckBox.checked ? 'bold' : 'normal'
                             }">
                          <!-- Recipient name -->
                          <div class="col-xs-5">
                            <i class="icon-user text-muted"></i>
                            <span class="recipient-name">{{recipient?.name || ('N/A' | translate)}}</span>
                          </div>

                          <!-- Email -->
                          <div class="col-xs-6">
                            <i class="icon-mail5 text-muted"></i>
                            <span class="recipient-email text-muted">{{recipient?.email || ('N/A' | translate)}}</span>
                          </div>

                          <!-- Checkbox -->
                          <div class="col-xs-1 text-right">
                            <input
                              [attr.id]="'recipient_' + recipient?.id"
                              #linkCheckBox
                              name="linkItemCheck"
                              type="checkbox"
                              class="styled"
                              (change)="linkCheckBoxChanged(linkCheckBox.checked, recipient)"
                              [attr.aria-label]="'Select ' + recipient?.name"
                            />
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br>

          <div class="form-group row position">
            <label for="returnURL" class="col-sm-2 col-form-label"><strong translate>Return URL</strong></label>
            <div class="col-sm-10">
              <input type="text" id="returnURL" class="form-control" [(ngModel)]="publicLinkReturnURL" placeholder="http://">
            </div>
          </div>

        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-link" type="button" data-dismiss="modal" translate>Cancel</button>
        <button type="button" class="btn btn-primary" (click)="createPublicLink()" translate>Done</button>
      </div>
    </div>
  </div>
</div>

<div id="publicLinkURL" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-md center-modal" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <button class="close" type="button" data-dismiss="modal">×</button>
        <h5 class="text-semibold modal-title" translate>Public Link</h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-12">
            <div class="input-group">
              <input type="text" class="form-control" readonly [(ngModel)]="publicLinkURL" #publicLink>
              <span class="input-group-btn">
                 <button class="btn btn-default" type="button" [ngxClipboard]="publicLink" (cbOnSuccess)="notificationService?.publicLinkCopied()"><span class="icon-copy3"></span> {{'COPY' | translate}}</button>
             </span>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary" type="button" data-dismiss="modal" translate>Close</button>
      </div>
    </div>
  </div>
</div>

<div id="bulkRequestFromCSVModal" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-lg center-modal" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <button class="close" type="button" (click)="resetCSVFileVariables()" data-dismiss="modal">×</button>
        <h5 class="text-semibold modal-title">CSV</h5>
      </div>
      <div class="modal-body">
        <div class="container-fluid">
          <!-- Show when no recipient groups -->
          <div *ngIf="!recipientGroups || recipientGroups.length === 0" class="alert alert-warning">
            <i class="icon-warning"></i> <span translate>No recipients configured for this template</span>
          </div>

          <!-- Render recipient groups -->
          <div *ngFor="let group of recipientGroups; let i = index" class="recipient-group">
            <div class="panel panel-flat border-grey-300 border-info inner-shadow">
              <div class="panel-body">
                <div class="row">
                  <!-- Order number column -->
                  <div class="col-md-1 col-sm-1 col-xs-1 text-center">
                    <div class="order-badge">
                      <strong>{{i+1}}</strong>
                    </div>
                  </div>

                  <!-- Recipients list -->
                  <div class="col-md-11 col-sm-11 col-xs-11 border-left">
                    <ul class="list-group no-border">
                      <li *ngFor="let recipient of group.recipients; let x = index" class="recipient-item">
                        <div class="row align-items-center"
                             style="padding: 10px 5px"
                             [ngStyle]="{
                               'background-color': linkCheckBox.checked ? '#EBEBEB' : 'transparent',
                               'font-weight': linkCheckBox.checked ? 'bold' : 'normal'
                             }">
                          <!-- Recipient name -->
                          <div class="col-xs-5">
                            <i class="icon-user text-muted"></i>
                            <span class="recipient-name">{{recipient?.name || ('N/A' | translate)}}</span>
                          </div>

                          <!-- Email -->
                          <div class="col-xs-6">
                            <i class="icon-mail5 text-muted"></i>
                            <span class="recipient-email text-muted">{{recipient?.email || ('N/A' | translate)}}</span>
                          </div>

                          <!-- Checkbox -->
                          <div class="col-xs-1 text-right">
                            <input
                              [attr.id]="'recipient_' + recipient?.id"
                              #linkCheckBox
                              name="linkItemCheck"
                              type="checkbox"
                              class="styled"
                              (change)="linkCheckBoxChanged(linkCheckBox.checked, recipient)"
                              [attr.aria-label]="'Select ' + recipient?.name"
                            />
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br>

          <div style="background-color: #DDDDDD; padding: 10px 10px">
            <p><strong translate>Signing information to be received from CSV</strong></p>
            <div class="row" *ngFor="let item of publicLinkItems; let i = index;">
              <div class="col-sm-3">
                <label class="control-label">{{item?.nick}}</label>
              </div>
              <div class="col-sm-9" style="margin-bottom: 10px">
                <div><label class="control-label">recipient{{i+1}}name</label></div>
                <div><label class="control-label">recipient{{i+1}}email</label></div>
                <div><label class="control-label">recipient{{i+1}}ID</label></div>
                <div><label class="control-label">recipient{{i+1}}CountryCode</label></div>
                <div><label class="control-label">recipient{{i+1}}PhoneNumber</label></div>
              </div>
            </div>
          </div>
          <br>
          <div style="background-color: #DDDDDD; padding: 10px 10px">
            <p><strong translate>Fields required for signers to fill</strong></p>
            <div class="row" *ngFor="let row of updatedCVInputs; let i = index;">
              <div class="col-sm-3">
                <label class="control-label">{{row.recipient.name}}</label>
              </div>
              <div class="col-sm-9" style="margin-bottom: 10px">
                <div *ngFor="let field of row.fields; let i = index;">
                  <label class="control-label">{{field.text}}</label>
                </div>
                <div *ngIf="row.fields.length==0">
                  <label class="control-label" translate>(Unavailable)</label>
                </div>
              </div>
            </div>
          </div>
          <br>
          <div class="text-center">
            <button type="button" class="btn btn-primary" (click)="downloadSampleCSVFile()" translate>Sample CSV File</button>
          </div>
          <br>
          <p class="text-left" translate>If you change the expected signer information in CSV, download the sample file again</p>
          <p class="text-left" translate>You can use the following to edit the sample file:</p><a href='https://www.libreoffice.org/'>LibreOffice</a> , <a href='https://edit-csv.net/'>edit-csv.net</a>
          <br><br>
          <div class="row position">
            <span class="col-sm-3" translate>Upload CSV File:</span>
            <input type="text" class="col-sm-7" readonly [(ngModel)]="csvFileName"/>
            <input
              #fileInput
              type="file"
              accept=".csv"
              (change)="onCSVFileSelected($event)"
              style="display: none;"
            >
            <button type="button" class="col-sm-2" (click)="fileInput.click()" translate>Browse</button>
          </div>
          <div *ngIf="uploadFile!==null && uploadResponse===null" class="text-info text-center">
            <br>
            <img src="../../assets/images/loading.gif">
          </div>
          <br>
          <div class="text-danger text-center">{{csvFileErrMsg}}</div>
          <div class="text-success text-center">{{csvFileSuccessMsg}}</div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-link" type="button" (click)="resetCSVFileVariables()" data-dismiss="modal" translate>Cancel</button>
        <button type="button" class="btn btn-primary" [loadingButton]="'csv-upload'" [disabled]="publicLinkItems.length==0 || csvFileErrMsg!='' || csvFileName==''" (click)="startUpload()" translate>Done</button>
      </div>
    </div>
  </div>
</div>


<div id="nicknameModal" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-md center-modal" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <button class="close" type="button" data-dismiss="modal">×</button>
        <h5 class="text-semibold modal-title" translate>Nickname</h5>
      </div>
      <div class="modal-body">
        <div class="container-fluid">
          <p [innerHTML]="'CSV_NICKNAME_EXPLANATION' | translate"></p>
          <br>
          <form #f="ngForm" novalidate>
            <div class="form-group">
              <input type="text" name="nickname" class="form-control" [(ngModel)]="publicLinkItem.nick" #nickname="ngModel" required minlength="2" pattern="^[0-9a-zA-ZsçÇöÖşŞıİğĞüÜ',. -]+$">
              <small [hidden]="publicLinkItemError==''" class="text-danger">{{publicLinkItemError}}</small>
            </div>
          </form>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-link" type="button" (click)="unSelectCheckBox()" data-dismiss="modal" translate>Cancel</button>
        <button type="button" class="btn btn-primary" [disabled]="!f.valid" (click)="updatePublicLinkRecipient()" translate>Done</button>
      </div>
    </div>
  </div>
</div>

<div id="createTemplate" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-sm center-modal" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <button class="close" type="button" data-dismiss="modal">×</button>
        <h5 class="text-semibold modal-title" translate>Create Template</h5>
      </div>
      <div class="modal-body">

        <form #f="ngForm" novalidate>
          <div class="form-group">
            <label for="category" class="control-label"><strong translate>Category</strong></label>
            <input type="text" id="category" name="category" class="form-control" [(ngModel)]="template.cetegory" #cetegory="ngModel">
          </div>
          <div class="form-group">
            <label for="definition" class="control-label"><strong translate>Definition</strong></label>
            <textarea class="form-control" id="definition" [(ngModel)]="template.definition" name="definition" #definition="ngModel" rows="6" cols="50"> </textarea>
          </div>
        </form>

      </div>
      <div class="modal-footer">
        <button class="btn btn-link" type="button" data-dismiss="modal" translate>Cancel</button>
        <button type="button" class="btn btn-primary" (click)="createTemplate()" [disabled]="false" translate>Create</button>
      </div>
    </div>
  </div>
</div>
